import { http } from '../http';
import type { Errors } from '@/data/models/Errors';

export abstract class Request<T = void> {
  abstract method: string | 'GET' | 'POST' | 'PUT' | 'DELETE';
  abstract url: string;

  // eslint-disable-next-line
  params?: any = undefined;
  // eslint-disable-next-line
  data?: any = undefined;

  async execute(): Promise<T> {
    if (this.params === undefined) {
      this.params = {};
    }

    this.params.event_prefix = process.env.VUE_APP_EVENT_PREFIX;

    const response = await http.request({
      method: this.method,
      url: this.url,
      params: this.params,
      data: this.data,
    });

    if (response.data.data) {
      return response.data.data;
    } else {
      return response.data;
    }
  }

  errors(data = this.data ?? {}, errors: Errors = {}): Errors {
    Object.keys(data).forEach((key) => {
      if (typeof data[key] === 'object') {
        errors[key] = {};
        this.errors(data[key], errors[key] as Errors);
      } else {
        errors[key] = undefined;
      }
    });

    return errors;
  }
}
